import axios from "axios";
import {endpoints} from "@api/apis";

export const getStampDutyCharges = async (payload: {
    requestedCreditLimit: string;
}) => {
    return await axios.get(`${endpoints.stampDutyCharges}${payload?.requestedCreditLimit}`);

}

export const overrideStateAPICall = async (payload: {
    applicationId: string,
    stampDutyState: string
}) => {
    return await axios.post(`${endpoints.overrideState}`, {
        creditApplicationId: payload.applicationId,
        stampDutyState: payload.stampDutyState
    });

}